<div class="singlerow" *ngIf="showFilters || showLegend">
  <div class="material-scope">
    <mat-form-field *ngIf="showFilters">
      <mat-label>Market Segment</mat-label>
      <mat-select [(ngModel)]="selectedMarket" (selectionChange)="getEngine()">
        <mat-option *ngFor="let item of market" [value]="item">
          {{ item }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="material-scope">
    <mat-form-field *ngIf="showFilters">
      <mat-label>Engine Model</mat-label>
      <mat-select [(ngModel)]="selectedEngine" (selectionChange)="onEngineChange()">
        <mat-option>
          <ngx-mat-select-search placeholderLabel="Search" ngModel (ngModelChange)="filterEngineSelection($event)"
            noEntriesFoundLabel="no matching engine found"></ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let item of filteredEngines" [value]="item">
          {{ item }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <table class="legend-table" *ngIf="showLegend">
   <tr>
          <td class="legend-cell"><strong>1</strong> – Market lagging</td>
          <td class="legend-cell"><strong>2</strong> – Slightly better than Market lagging</td>
          <td class="legend-cell"><strong>3</strong> – Low performer</td>
          <td class="legend-cell"><strong>4</strong> – Slightly worse than Market average</td>
        </tr>
        <tr>
          <td class="legend-cell"><strong>5</strong> – Market average</td>
          <td class="legend-cell"><strong>6</strong> – Slightly better than Market average</td>
          <td class="legend-cell"><strong>7</strong> – Somewhat better than Market average</td>
          <td class="legend-cell"><strong>8</strong> – Better than Market average</td>
        </tr>
        <tr>
          <td class="legend-cell"><strong>9</strong> – Very close to being Market leading</td>
          <td class="legend-cell"><strong>10</strong> – Market eading</td>
          <td class="legend-cell"><strong>N/A</strong> – Not Applicable/Don't know</td>
        </tr>
  </table>
</div>
<div class="table-container" [class.embedded]="embedded">
<table mat-table [dataSource]="dataSource" class="mat-elevation-z8" style="width: 100%">
  <!-- Product Column -->
  <ng-container matColumnDef="product">
    <th mat-header-cell *matHeaderCellDef>Product</th>
    <td mat-cell *matCellDef="let element">{{ element.product }}</td>
    <td mat-footer-cell *matFooterCellDef>Avg Score</td>
  </ng-container>

  <ng-container matColumnDef="keycompetitor">
    <th mat-header-cell *matHeaderCellDef>Key Competitor</th>
    <td mat-cell *matCellDef="let element">
      {{ element.keyCompetitor }}
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <!-- User Column -->
  <ng-container matColumnDef="user">
    <th mat-header-cell *matHeaderCellDef>User</th>
    <td mat-cell *matCellDef="let element">{{ element.email }}</td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <!-- Editable Score Columns -->
  <ng-container matColumnDef="tco">
    <th mat-header-cell *matHeaderCellDef>
      <div style="
          display: flex;
          justify-content: space-around;
          align-items: center;
        ">
        TCO
        <mat-icon class="info-icon" [matTooltip]="getToolTip('TCO')">help</mat-icon>
      </div>
    </th>
    <td mat-cell *matCellDef="let element">
      <input matInput class="scoreInput" type="number" [(ngModel)]="element.TCO" [min]="1" [max]="10"
        (ngModelChange)="calculateAverages()" />
    </td>
    <td class="text-right" mat-footer-cell *matFooterCellDef>
      {{ averageValues.TCO | number : "1.1-1" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="affordability">
    <th mat-header-cell *matHeaderCellDef>
      <div style="
          display: flex;
          justify-content: space-around;
          align-items: center;
        ">
        Affordability
        <mat-icon class="info-icon" [matTooltip]="getToolTip('affordability')">help</mat-icon>
      </div>
    </th>
    <td mat-cell *matCellDef="let element">
      <input class="scoreInput" matInput type="number" [(ngModel)]="element.affordability" [min]="1" [max]="10"
        (ngModelChange)="calculateAverages()" />
    </td>
    <td class="text-right" mat-footer-cell *matFooterCellDef>
      {{ averageValues.affordability | number : "1.1-1" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="availability">
    <th mat-header-cell *matHeaderCellDef>
      <div style="
          display: flex;
          justify-content: space-around;
          align-items: center;
        ">
        Availability
        <mat-icon class="info-icon" [matTooltip]="getToolTip('availability')">help</mat-icon>
      </div>
    </th>
    <td mat-cell *matCellDef="let element">
      <input class="scoreInput" matInput type="number" [(ngModel)]="element.availability" [min]="1" [max]="10"
        (ngModelChange)="calculateAverages()" />
    </td>
    <td class="text-right" mat-footer-cell *matFooterCellDef>
      {{ averageValues.availability | number : "1.1-1" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="productivity">
    <th mat-header-cell *matHeaderCellDef>
      <div style="
          display: flex;
          justify-content: space-around;
          align-items: center;
        ">
        Productivity
        <mat-icon class="info-icon" [matTooltip]="getToolTip('productivity')">help</mat-icon>
      </div>
    </th>
    <td mat-cell *matCellDef="let element">
      <input class="scoreInput" matInput type="number" [(ngModel)]="element.productivity" [min]="1" [max]="10"
        (ngModelChange)="calculateAverages()" />
    </td>
    <td class="text-right" mat-footer-cell *matFooterCellDef>
      {{ averageValues.productivity | number : "1.1-1" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="sustainability">
    <th mat-header-cell *matHeaderCellDef>
      <div style="
          display: flex;
          justify-content: space-around;
          align-items: center;
        ">
        Sustainability
        <mat-icon class="info-icon" [matTooltip]="getToolTip('sustainability')">help</mat-icon>
      </div>
    </th>
    <td mat-cell *matCellDef="let element">
      <input class="scoreInput" matInput type="number" [(ngModel)]="element.sustainability" [min]="1" [max]="10"
        (ngModelChange)="calculateAverages()" />
    </td>
    <td class="text-right" mat-footer-cell *matFooterCellDef>
      {{ averageValues.sustainability | number : "1.1-1" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="notes">
    <th mat-header-cell *matHeaderCellDef>Notes/Comments</th>
    <td mat-cell *matCellDef="let element">
      {{ element.notes }}
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <ng-container matColumnDef="delete">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element; let i = index">
      <button mat-icon-button color="warn" (click)="deleteRow(i, element)">
        <mat-icon>delete</mat-icon>
      </button>
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <!-- Table Rows -->
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  <tr mat-footer-row *matFooterRowDef="displayedColumns;sticky: true"></tr>
</table>
</div>
<div class="lower-container" *ngIf="showActions">
  <button class="btn" routerLink="/survey-data">
    Survey Data
  </button>
  <button class="reset" (click)="resetSelection()" mat-flat-button color="warn">
    Reset
  </button>
  <button class="btn" (click)="save()">Save</button>
</div>
